import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/icons/calender-icon";
import { useSelector } from "react-redux";

const MarkAsCompleteForm = ({
  OndataChange,
  error,
  recruiterName,
  recruiterID,
}) => {
  const datePickerStartDateRef = useRef(null);
  const [recruiterList, setRecruiterList] = useState([]);
  const recruiter_list = useSelector((state) => state.recruiter_list);
  console.log("recruiterName", recruiterName);
  const [data, setData] = useState({
    completedBy: recruiterID || "",
    completedOn: new Date(),
    reasonForCompletion: "",
  });

  console.log("MarkAsCompleteForm data", data);
  console.log("MarkAsCompleteForm recruiterList", recruiterList);

  const OnChange = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    const newData = { ...data, [field]: value };
    setData(newData);
  };

  useEffect(() => {
    OndataChange(data);
  }, [data]);

  useEffect(() => {
    if (recruiter_list && recruiter_list.data && recruiter_list.data.items) {
      const filteredList = recruiter_list.data.items.filter(
        (item) => item.hasCalendar === true
      );
      if (filteredList.length > 0) {
        var recruiters = filteredList.map((x) => ({
          name: `${x.firstName} ${x.lastName}`,
          id: x.recruiterID,
        }));
        setRecruiterList(recruiters);
      } else {
        setRecruiterList([]);
      }
    }
  }, [recruiter_list]);

  return (
    <div className="max-w-4xl font-sans  mt-3">
      {/* Top Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Completed By */}
        <div>
          <label className="block text-sm font-medium text-gray-800 mb-2">
            Completed By<span className="text-red-500">*</span>
          </label>

          <div className="relative">
            <select
              className="w-full appearance-none rounded-lg border border-[#667783] px-4 py-3 text-sm"
              name="completedBy"
              onChange={(e) => OnChange(e)}
              value={data.completedBy}
            >
              <option value={""} selected disabled>
                Select Recruiter
              </option>
              {recruiterList?.map((tz) => (
                <option key={tz.id} value={tz.id}>
                  {tz.name}
                </option>
              ))}
            </select>

            <span className="absolute right-3.5 top-[45%] h-5 w-5 transform -translate-y-1/2 pointer-events-none bg-white">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                  stroke="#278EFF"
                  strokeWidth="2"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>

          {error.completedBy && (
            <div className="mt-1">
              <p className="text-[#F95454] font-mont text-[14px] font-[500]">
                Completed by is required
              </p>
            </div>
          )}
        </div>

        {/* Completed On */}
        <div>
          <label className="block text-sm font-medium text-gray-800 mb-2">
            Completed On<span className="text-red-500">*</span>
          </label>

          <div className="relative">
            <DatePicker
              selected={data.completedOn ?? null}
              onChange={(date) => {
                //setStartDate(date);
                //if (date && date > endDate) setEndDate(date);
                setData({ ...data, completedOn: date });
              }}
              // minDate={new Date()}
              //dateFormat="dd MMM yyyy"
              dateFormat="MM/dd/yyyy"
              placeholderText="Select"
              popperPlacement="bottom-start"
              popperClassName="!z-50"
              autoComplete="off"
              showPopperArrow={false}
              calendarClassName="rounded-xl border shadow-lg"
              className={`border_color border text-base rounded-lg block w-full p-0 appearance-none text-base rounded-lg block w-full p-2 h-12 appearance-none max-h-[46px]`}
              ref={datePickerStartDateRef}
            />
            <div onClick={() => datePickerStartDateRef.current?.setOpen(true)}>
              <CalendarIcon
                className="absolute right-3 top-1/2  -translate-y-1/2 text-[#278EFF]"
                color="#278EFF"
              />
            </div>
          </div>

          {error.completedOn && (
            <div className="mt-1">
              <p className="text-[#F95454] font-mont text-[14px] font-[500]">
                Completed On is required
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="mt-6">
        <label className="block text-sm font-medium text-gray-800 mb-2">
          Reason for Completion<span className="text-red-500">*</span>
        </label>

        <textarea
          value={data.reasonForCompletion}
          onChange={(e) => OnChange(e)}
          maxLength={500}
          rows={4}
          name="reasonForCompletion"
          className="w-full rounded-lg border border-[#667783] px-4 py-3 text-sm resize-none"
        />

        <div className="mt-1 text-sm text-gray-500 flex justify-between">
          <p>{data.reasonForCompletion.length}/500</p>
          {error.reasonForCompletion && (
            <p className="text-[#F95454] font-mont text-[14px] font-[500]">
              Reason for Completion is required
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarkAsCompleteForm;
